type AddressResult = {
  readonly street_line?: string
  readonly state?: string
  readonly zipcode?: string
  readonly city?: string
}

const normalizeAddressResult = (
  addressValue: unknown,
): Required<Pick<AddressResult, 'street_line' | 'state' | 'zipcode' | 'city'>> => {
  if (!addressValue || typeof addressValue !== 'object' || Array.isArray(addressValue)) {
    return { street_line: '', state: '', zipcode: '', city: '' }
  }

  const addressRecord: Record<string, unknown> = addressValue as Record<string, unknown>

  return {
    street_line: typeof addressRecord.street_line === 'string' ? addressRecord.street_line : '',
    state: typeof addressRecord.state === 'string' ? addressRecord.state : '',
    zipcode: typeof addressRecord.zipcode === 'string' ? addressRecord.zipcode : '',
    city: typeof addressRecord.city === 'string' ? addressRecord.city : '',
  }
}

export default normalizeAddressResult
